module.exports = __webpack_public_path__ + "static/leader-step2.6333e41c.png";